import styled from '@emotion/styled';
import CheckInput from '../CheckInput/CheckInput';

// eslint-disable-next-line import/prefer-default-export
export const FieldWrapper = styled.label({
  display: 'block',
  lineHeight: '2rem',
  paddingLeft: 30,
});

export const StyledCheckInput = styled(CheckInput)({
  position: 'relative',
  top: 2,
  right: 30,
});

export const LabelText = styled.span({
  display: 'block',
  cursor: 'pointer',
});
